import { routerMiddleware } from 'connected-react-router';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer from 'react/api/reducers';
import onError from 'react/api/GlobalErrorHandler.js';
import history from 'react/api/history';
import sagas from 'react/api/sagas';

const sagaMiddleware = createSagaMiddleware({ onError });

const store = configureStore({
  devTools: true,
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false
  }).concat(
    sagaMiddleware,
    routerMiddleware(history)
  )
});

sagaMiddleware.run(sagas);
window.globalStore = store;
window.GreenmileReduxStore = store;
window.lastPath = '';

export { store };
